export default "__VITE_ASSET__e864080d__"